import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment FeedbackForLeaderFragment on FeedbackForLeader {
    uid
    activity_star_rating
    created_at
    details {
      leaderFeedback
    }
  }
`;
